import Image from "next/image";
import Link from "next/link";
import { Br } from "@/components/molecules/Br";

export const AiRedesignLab = () => {
  return (
    <div className="col-span-1 space-y-4 md:space-y-6">
      <figure className="relative block aspect-[16/9] w-full overflow-hidden rounded-lg md:aspect-[21/9]">
        <Image
          src="/ai-redesign-lab-banner.png"
          alt="AI共創型システムリデザイン・ラボ"
          quality={90}
          layout="fill"
          objectFit="cover"
        />
      </figure>
      <div className="space-y-4 px-6 py-2 sm:px-8 md:px-12 md:py-4 lg:py-5">
        <div className="space-y-3">
          <h3 className="font-bold text-pri fluid-text-[18px,26px]">
            AI共創型システムリデザイン・ラボ
          </h3>
          <p className="font-bold text-ter fluid-text-[14px,18px]">
            既存システム課題をAIが可視化・構造化し、
            <Br sp />
            改善から運用まで伴走
          </p>
        </div>
        <div className="space-y-4 leading-comfort text-txt-base fluid-text-[14px,18px]">
          <p>
            既存システムの課題を「見える化」し、優先順位を付けて段階的に改善します。
            <Br sp />
            AIと専門チームが提案から実装、運用まで一気通貫で伴走し、
            <Br sp />
            お客様のシステムを持続的に進化させます。
          </p>
          <div className="space-y-2">
            <h4 className="font-bold text-ter fluid-text-[13px,17px]">
              サービスの特徴
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>AI分析による健康診断</strong>：システムの健全性をスコア化し、改善箇所を可視化
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>段階的な改善ロードマップ</strong>：小さく始めて効果検証し、本格展開へ
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>AI補助開発</strong>：最新のAIツールを活用し、高速・高品質な開発を実現
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>継続的な保守運用支援</strong>：AI監視と健康ダッシュボードで安定運用をサポート
                </span>
              </li>
            </ul>
          </div>
          <div className="space-y-2">
            <h4 className="font-bold text-ter fluid-text-[13px,17px]">
              こんな課題を解決します
            </h4>
            <ul className="space-y-1">
              <li className="flex items-start gap-2">
                <span className="mt-1 text-ter">•</span>
                <span>システムが古く、担当者しか分からない（ブラックボックス化）</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 text-ter">•</span>
                <span>ちょっとした改修でも時間とコストがかかる</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 text-ter">•</span>
                <span>セキュリティや監査対応に不安がある</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 text-ter">•</span>
                <span>データがバラバラで意思決定が遅い</span>
              </li>
            </ul>
          </div>
          <Link href="/contact/redesign_labo/form">
            <a className="block rounded-lg bg-bgc-dark p-4 md:p-5 transition-opacity hover:opacity-80">
              <p className="text-center font-bold text-pri fluid-text-[13px,17px]">
                まずは無料ミニ診断（1〜2週間）から始められます　お申込みはこちら
              </p>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};
